import { useTranslate } from "src/i18n";

export const useSpuConverterPageTranslate = () => {
  const { t } = useTranslate();

  return {
    linksEditorTitle: t(
      "spu_converter_page.links_editor.title",
      "Ссылки на товары",
    ),
    spuIdEditorTitle: t(
      "spu_converter_page.spu_id_editor.title",
      "SpuID товаров",
    ),
    productIdEditorTitle: t(
      "spu_converter_page.product_id_editor.title",
      "ProductID товаров",
    ),
    formatButton: t(
      "spu_converter_page.actions.format.button",
      "Форматировать",
    ),
    convertButton: t(
      "spu_converter_page.actions.convert.button",
      "Конвертировать",
    ),
    addSelectedButton: t(
      "spu_converter_page.actions.add_selected.button",
      "Добавить к выбранным",
    ),
  };
};
